export default __webpack_public_path__ + "static/media/baptisan.d8c8400f.png";